// @flow

import React, { Component } from 'react';
import type { Node } from 'react';
import { connect } from 'react-redux';
import {
  fetchSettings,
  getSettings,
  needsLoading as needsLoadingSelector,
  isFetching as isFetchingSelector,
} from '../../store/settings';
import type { Settings } from '../../store/settings';
import type { FixMe } from '../../types/any';

// withSettings will give you:
export type WithSettingsProps = {|
  settings: Settings,
|};

// @TODO: create HoC typing https://justlease.atlassian.net/browse/LISTO-304
const withSettings = () => (WrappedComponent: FixMe) => {
  type OwnProps = {|
    children: Node,
  |};

  type StateProps = {|
    isFetching: boolean,
    needsLoading: boolean,
    settings: Settings,
  |};

  type DispatchProps = {|
    fetch: Function,
  |};

  type Props = {|
    ...OwnProps,
    ...StateProps,
    ...DispatchProps,
  |};

  class WithSettings extends Component<Props> {
    componentDidMount() {
      const { needsLoading, fetch } = this.props;
      if (needsLoading) {
        fetch();
      }
    }

    render() {
      const {
        needsLoading,
        fetch,
        isFetching,
        ...props
      } = this.props;

      if (needsLoading || isFetching) {
        return <div>Loading...</div>;
      }

      return <WrappedComponent {...props} />;
    }
  }

  const mapStateToProps = (state): StateProps => ({
    isFetching: isFetchingSelector(state),
    needsLoading: needsLoadingSelector(state),
    settings: getSettings(state),
  });

  const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
    fetch: () => dispatch(fetchSettings()),
  });

  return connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
    mapStateToProps,
    mapDispatchToProps,
  )(WithSettings);
};

export default withSettings;
